import $ from 'jquery';

class Random {
  constructor(target) {
    this.list = target.find('li');
    this.max = this.list.length;
    this._reset();
    this._setClass();
  }

  _reset() {
    this.list.find('img').removeClass();
  }

  _setClass() {
    this.list.each(
      function (index, el) {
        var rNum = this._getRandom();
        var img1 = $(el).find('img')[0];
        var img2 = $(el).find('img')[1];
        $(img1).addClass('js-lineup__random--' + rNum);
        $(img2).addClass('js-lineup__random--' + rNum + 'b');
      }.bind(this),
    );
  }

  _getRandom() {
    return Math.floor(Math.random() * 13) + 7;
  }
}

(() => {
  const targets = $('.js-lineup__product');
  if (!targets.length) return;
  new Random(targets);
})();
